import React from "react";
import { Container } from "react-bootstrap";
// import "./TechnologyMarquee.css"; // CSS animasi

// Ambil semua gambar dari folder assets/partner
function importAll(r) {
  return r.keys().map((key, idx) => ({
    id: idx,
    url: r(key),
    alt: key.replace("./", ""),
  }));
}

const partnerImages = importAll(require.context("../assets/partner", false, /\.(png|jpe?g|svg)$/));

const OurTechnology = ({ images = partnerImages }) => {
  return (
    <Container className="py-5 partner text-center">
      <h2 className="mb-5">
        <span style={{ color: "#348CFF" }}>Our Technology</span>{" "}
        <span style={{ color: "#000" }}>Partner</span>
      </h2>

      <div className="logo-marquee marquee-left">
        <div className="logo-track">
          {images.concat(images).map((logo, idx) => (
            <div className="logo-item" key={idx}>
              <img src={logo.url} alt={logo.alt} style={{ maxHeight: "80px", width: "auto" }} />
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default OurTechnology;